import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core'
import Swal from 'sweetalert2'
import { AuthenticationService } from '../../_services/authentication.service'
import { RequestsService } from '../../_shared/services/requests.service'

declare var jQuery: any
@Component({
  selector: 'app-post-diagnosis-modal',
  templateUrl: './post-diagnosis-modal.component.html',
  styleUrls: ['./post-diagnosis-modal.component.scss'],
})
export class PostDiagnosisModalComponent implements OnInit {
  @Input() category: string
  model: any = {}
  submitted = false
  success = false
  loading = false
  maxSizeError: boolean = false
  crops: any
  country_id: string
  countryName: string
  message: string
  file: File = null
  status: string
  explanationTitle: string
  inputs: any
  filterInputs: any
  searchItem: string
  parts: any

  requiredField: any = {
    control: false,
    explanation: false,
    photo: false,
  }

  selectedImage: File = null
  processPhoto(event) {
    this.selectedImage = <File>event.target.files[0]
    if (this.selectedImage.size > 600000) {
      this.maxSizeError = true
    } else {
      this.maxSizeError = false
    }
  }

  @Output() reloadDiagnosisEvent = new EventEmitter()

  // quillJS editor config
  quillConfig = {
    toolbar: [
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['bold', 'italic', 'underline'],
      [{ header: 1 }, { header: 2 }],
      ['clean'],
    ],
  }

  constructor(
    private requestService: RequestsService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit() {
    // this.parts = ['Spraying','Soil testing','Tractor hire','Garden mapping'];
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country_id, country } = currentUser
    this.country_id = country_id
    this.countryName = country

    if (this.countryName === 'Uganda') {
      this.parts = [
        'Spraying',
        'Soil testing',
        'Tractor hire',
        'Garden mapping',
      ]
    } else if (this.countryName === 'India') {
      this.parts = ['Garden mapping']
    }

    this.getCrops()
    this.getInputs()
    this.displayExplanation(this.category)
  }

  displayExplanation(category) {
    this.explanationTitle = category === 'pest' ? 'effects' : 'symptoms'
  }

  getInputs() {
    this.loading = true
    this.requestService
      .dash_get(`mobile/input/${this.countryName}`, null)
      .subscribe((res) => {
        this.loading = false
        this.inputs = res.data
        this.filterInputs = res.data
      })
  }

  filterFunction() {
    this.searchItem = jQuery('#searchBox').val()
    // console.log(this.inputs);
    this.filterInputs = this.inputs.filter(
      (input) =>
        input.name.toLowerCase().indexOf(this.searchItem.toLowerCase()) !== -1
    )
    // console.log(this.searchItem);
  }

  getCrops() {
    this.loading = true
    this.requestService
      .dash_get(`enterprises/${this.countryName}`, null)
      .subscribe((res) => {
        this.loading = false
        this.crops = res
      })
  }

  postDiagnosis(data: object) {
    this.loading = true
    this.requestService
      .dash_putWithImage(`diagnosis/${this.countryName}/${this.category}`, data)
      .subscribe(
        (res) => {
          this.loading = false
          this.message = res.message
          this.success = true
          this.status = 'success'
          this.refreshDiagnosisInfo()
          // this.displayAlert(this.message, this.status);
          // this.closeModal();
        },
        (err) => {
          const { error } = err
          this.loading = false
          this.status = 'error'
          this.message = error.error
          this.displayAlert(this.message, this.status)
        }
      )
  }

  closeModal() {
    jQuery(document).ready(() => {
      jQuery('#diagnosisForm')[0].reset()
      jQuery('#diagnosisCrop').val('')
      jQuery('#diagnosisModal').modal('hide')
    })
  }

  resetCreateModal() {
    jQuery('#diagnosisForm')[0].reset()
    jQuery('#diagnosisCrop').val('')
    jQuery('#diagnosisModal').modal('hide')
    this.status = null
    this.message = null
    this.selectedImage = <File>null
  }

  handleSubmit(createDiagnosisForm) {
    this.submitted = true
    const formData = new FormData()
    formData.append('name', createDiagnosisForm.name)
    formData.append('cause', createDiagnosisForm.cause)
    formData.append('crop', createDiagnosisForm.crop)
    formData.append('control', createDiagnosisForm.control)
    formData.append('explanation', createDiagnosisForm.explanation)
    formData.append('input', createDiagnosisForm.input)
    formData.append('service', createDiagnosisForm.service)

    if (this.selectedImage) {
      formData.append('photo', this.selectedImage, this.selectedImage.name)
    }
    this.postDiagnosis(formData)
    // if (!createDiagnosisForm.control) {
    //   this.requiredField.control = true;
    // } else if (!createDiagnosisForm.explanation) {
    //   this.requiredField.explanation = true;
    // } else if (!this.file || !(/\.(jpg|jpeg|png)$/i).test(this.file.name) || this.file.size > 2000000) {
    //   this.requiredField.photo = true;
    // } else {
    //   formData.append('name', createDiagnosisForm.name);
    //   formData.append('cause', createDiagnosisForm.cause);
    //   formData.append('crop', createDiagnosisForm.crop);
    //   formData.append('control', createDiagnosisForm.control);
    //   formData.append('explanation', createDiagnosisForm.explanation);
    //   formData.append('photo', this.file, this.file.name);

    //   this.postDiagnosis(formData);
    // }
  }

  displayAlert(message, status) {
    const title = status.charAt(0).toUpperCase() + status.slice(1)
    Swal.fire(title, message, status)
  }

  refreshDiagnosisInfo() {
    this.reloadDiagnosisEvent.emit()
  }

  clearErrorMessage(input) {
    if (input.name === 'explanation') {
      this.requiredField.explanation = false
    } else if (input.name === 'control') {
      this.requiredField.control = false
    }
  }
}
